module.exports = __webpack_public_path__ + "img/info.916fdadb.svg";